<template>
  <el-row type="flex" justify="start" align="middle" id="list-view-header">
    <HeaderInfoText :colspan="9" :title="title" :meta="meta" :selection="selection"></HeaderInfoText>
    <el-col :span="6">
      <el-row type="flex" justify="center" v-if="meta.count > pageSize">
        <el-pagination
          layout="prev, pager, next, jumper"
          :total="meta.count"
          :page-size="pageSize"
          @current-change="changePage"
          :current-page="currentPage">
        </el-pagination>
      </el-row>
    </el-col>
    <el-col :span="9" class="h-padded right-aligned-col">
      <!-- CP (Vue 3): restored from CPA-Production — the inner flex wrapper is what right-aligns and baseline-
           aligns the "With selected" select + Hide-filters + Add controls. Dropping it un-aligned them. -->
      <div style="display: flex; align-items: end; justify-content: end;">
        <el-select
          v-if="meta.count"
          :disabled="!(selection && selection.length)"
          placeholder="With selected..."
          v-model="batchUpdateSelection"
          style="width: 207px; margin-left: 70px;"
          @change="handleSelection">
          <el-option
            v-for="(option, i) in batchUpdateOptions"
            :key=i
            :label="option.text"
            :value=i
            :disabled="option.disabled">
          </el-option>
        </el-select>
        <slot></slot>
        <el-button plain style="margin: 0 6px;" @click="toggleFilters" data-testid="list-toggle-filters-btn">
          {{ showFilters ? "Hide filters" : "Show filters" }}
        </el-button>
        <router-link v-if="showNewRoute" :to="{name: createRouteName }">
          <el-button type="primary" icon="plus" :disabled="!hasCreatePermission" data-testid="list-new-btn" />
        </router-link>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import HeaderInfoText from '@/components/HeaderInfoText'

  export default {
    components: {
      HeaderInfoText
    },
    props: {
      pageSize: {
        'type': Number,
        'required': false,
        'default': 20
      },
      title: {
        'type': String,
        'required': true,
        'default': ''
      },
      meta: {
        'type': Object,
        'required': true
      },
      selection: {
        'type': Array,
        'required': false,
        'default': []
      },
      currentPage: {
        'type': Number,
        'required': false,
        'default': 1
      },
      changePage: {
        'type': Function,
        'required': false
      },
      handleBatchUpdateSelection: {
        'type': Function,
        'required': false
      },
      batchUpdateOptions: {
        'type': Array,
        'required': false
      },
      showFilters: {
        'type': Boolean,
        'required': false,
        'default': false
      },
      toggleFilters: {
        'type': Function,
        'required': false
      },
      hasCreatePermission: Boolean,
      createRouteName: {
        'type': String,
        'required': true
      },
      showNewRoute: {
        'type': Boolean,
        'required': false,
        'default': true
      }
    },
    data () {
      return {
        batchUpdateSelection: null
      }
    },
    methods: {
      /**
       * Handles the selection from the 'With Selected...' select menu. If this.confirmPosting is true and there is
       * no 'confirmed' argument passed or that argument is false, displays a dialog box that asks the user to
       * confirm that they want to post whatever open/audited transactions are in the selection.
       * @param choice
       * @param confirmed
       */
      handleSelection (choice, confirmed = false) {
        if (choice === null) {
          return
        }
        if (this.$store.getters.getUiSettings['CONFIRM_ON_POST'] && !confirmed) {
          this.showPostingConfirmationDialog(choice)
        } else {
          this.handleBatchUpdateSelection(choice)
        }
      },
      /**
       * Shows a confirmation dialog when a user tries to post the transaction
       * @return {Promise<void>}
       */
      async showPostingConfirmationDialog (choice) {
        try {
          await this.$confirm('Do you wish to post these transactions?', 'Confirm Posting', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })
          this.handleSelection(choice, true)
        } catch (e) {
          console.log(e)
        } finally {
          this.batchUpdateSelection = null
        }
      }
    }
  }
</script>

<style scoped>
  #list-view-header {
    border-bottom: 1px solid lightgray;
  }
  .h-padded {
    padding: 0 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
</style>
